module.exports = __webpack_public_path__ + "static/media/mobile-bg.10416257.png";